// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  baseurl: "https://api.eeasy.co/ni-wellness/",
  // baseurl: "http://localhost:3013/",
  production: false,
  defaultauth: "",
  firebaseConfig: {
    apiKey: "AIzaSyBh183wYslEHi-APaApLdiAXuovtgxOVgE",
    authDomain: "freelancer-72e1c.firebaseapp.com",
    projectId: "freelancer-72e1c",
    storageBucket: "freelancer-72e1c.appspot.com",
    messagingSenderId: "731722431959",
    appId: "1:731722431959:web:308709fab8e36e1ebf1f92",
    measurementId: "G-TZPP9JVKQY",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
